import {
  ResponseTransfer,
  RequestTransfer,
  RequestNewCaptain,
  ResponseNewCaptain,
} from '@/types/team';
import { ResponseNewCaptainF5, ResponseTransferF5 } from '@/types/teamf5';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

const headers = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};
export const requestTransfer = axiosErrorHandler(
  async (dataTransfer: RequestTransfer, isF5: boolean) => {
    if (!isF5) {
      const url = URLs.EQUIPO_11.HACER_TRANFERENCIA;
      const response = await axiosGdt.post<ResponseTransfer>(
        url,
        dataTransfer,
        headers
      );
      return response.data;
    } else {
      const url = URLs.EQUIPO_5.HACER_TRANFERENCIA;
      const response = await axiosGdt.post<ResponseTransferF5>(
        url,
        dataTransfer,
        headers
      );
      return response.data;
    }
  },
  TEXTS.defaultError
);

export const requestNewCaptain = axiosErrorHandler(
  async (data: RequestNewCaptain, isF5: boolean) => {
    if (!isF5) {
      const url = URLs.EQUIPO_11.HACER_CAPITAN;
      const response = await axiosGdt.post<ResponseNewCaptain>(
        url,
        data,
        headers
      );
      return response.data;
    } else {
      const url = URLs.EQUIPO_5.HACER_CAPITAN;
      const response = await axiosGdt.post<ResponseNewCaptainF5>(
        url,
        data,
        headers
      );
      return response.data;
    }
  },
  TEXTS.defaultError
);
